import { BaseMenu } from './BaseMenu';
import { MenuContextProvider } from './context';
import { MenuProps } from './types';

export const Menu = (props: MenuProps) => (
  <MenuContextProvider Menu={BaseMenu}>
    <BaseMenu {...props} />
  </MenuContextProvider>
);
